import { http } from "@/utils/request";
import type {
  Code,
  CodesResponse,
  GetCodesParams,
  CreateCodesParams,
  PartnerParams,
  Partner,
  AddPartnerParams
} from "@/types/code";

export const codeService = {
  // 获取兑换码列表
  getCodes: async (
    params: GetCodesParams
  ): Promise<CodesResponse> => {
    return http.get<CodesResponse>("/exchange/list", params);
  },
  // 创建兑换码批次
  createCodes: async (params: CreateCodesParams): Promise<Code> => {
    return http.post<Code>("/exchange",params)
  },
  // 兑换码批次导出
  downloadCodesBatch: async (params: GetCodesParams): Promise<Blob> => {
    return http.get<Blob>("/exchange/export",params,{
      responseType: "blob"
    })
  },
  // 下载兑换码详情
  downloadCodes: async (params: GetCodesParams | {page:number,page_size: number,code_id: number}): Promise<Blob> => {
    return http.get<Blob>("/exchange/details/export",params,{
      responseType: "blob"
    })
  },
  // 获取兑换码批次详情列表
  getCodesDetailList: async (params: GetCodesParams) => {
    return http.get(`/exchange/details/list`,params)
  },
  // 获取兑换码批次详情
  getCodesDetail: async (id: string) => {
    return http.get(`/exchange/${id}`)
  },
  // 获取合作伙伴列表
  getPartners: async(params:PartnerParams): Promise<Partner[]> => {
    return http.get<Partner[]>("/partner/list",params)
  },
  addPartner: async(params: AddPartnerParams): Promise<Partner> => {
    return http.post<Partner>("/partner",params)
  },
  getOptionsList: async (params: string) => {
    return http.get("/system/list",{types: params })
  },
  // 设置兑换码批次失效
  setInvalid: async ({id,reason}: {id: string,reason: string}) => {
    return http.put(`/exchange/invalidate/${id}`,{reason})
  },
  // 设置兑换码批次生效
  setValid: async ({id,reason}: {id: string,reason: string}) => {
    return http.put(`/exchange/validate/${id}`,{reason})
  },
  // 批量设置兑换码详情失效
  setInvalidBatch: async (codes: string[]) => {
    return http.put("/exchange/invalidate",{
      codes
    })
  },
  // 批量核销
  setCheckBatch: async (codesObj: {[key: string]: string}) => {
    return http.put("/exchange/verify",{
      phone_code_map:codesObj
    })
  },

  // 批量设置生效模板
  getInvalidateTemplate: async (): Promise<Blob> => {
    return http.get("/exchange/export/invalidate",{},{
      responseType: "blob"
    })
  },
  //批量核销模板
  getVerifyTemplate: async (): Promise<Blob> => {
    return http.get("/exchange/export/verify",{},{
      responseType: "blob"
    })
  }



  // 导出兑换码列表
  // exportCodes: async (params: GetCodesParams): Promise<Blob> => {
  //   // 待更新
  //   return http.get<Blob>("/code/export", params, {
  //     responseType: "blob",
  //   });
  // },
};
